import * as actions from './actions';

export default (state = {}, action) => {
  switch (action.type) {
    case actions.GET_LIST.REQUEST:
      return {
        ...state,
        listFetching: true,
      };
    case actions.GET_LIST.SUCCESS:
    case actions.GET_LIST.FAILURE:
      return {
        ...state,
        listFetching: false,
      };
    case actions.GET.REQUEST:
      return {
        ...state,
        valueFetching: true,
      };
    case actions.GET.SUCCESS:
    case actions.GET.FAILURE:
      return {
        ...state,
        valueFetching: false,
      };
    case actions.GET_TEMPLATE.REQUEST:
      return {
        ...state,
        templateFetching: true,
      };
    case actions.GET_TEMPLATE.SUCCESS:
    case actions.GET_TEMPLATE.FAILURE:
      return {
        ...state,
        templateFetching: false,
      };
    case actions.GET_ITEMS_CONFIGURATION.REQUEST:
      return {
        ...state,
        itemsConfigurationFetching: true,
      };
    case actions.GET_ITEMS_CONFIGURATION.SUCCESS:
    case actions.GET_ITEMS_CONFIGURATION.FAILURE:
      return {
        ...state,
        itemsConfigurationFetching: false,
      };
    case actions.UPDATE_ITEMS_CONFIGURATION.REQUEST:
      return {
        ...state,
        itemsConfigurationUpdating: true,
      };
    case actions.UPDATE_ITEMS_CONFIGURATION.SUCCESS:
    case actions.UPDATE_ITEMS_CONFIGURATION.FAILURE:
      return {
        ...state,
        itemsConfigurationUpdating: false,
      };
    case actions.GET_STATUSES.REQUEST:
      return {
        ...state,
        statusFetching: true,
      };
    case actions.GET_STATUSES.SUCCESS:
    case actions.GET_STATUSES.FAILURE:
      return {
        ...state,
        statusFetching: false,
      };
    case actions.UPSERT_STATUS.REQUEST:
      return {
        ...state,
        statusUpserting: true,
      };
    case actions.UPSERT_STATUS.SUCCESS:
    case actions.UPSERT_STATUS.FAILURE:
      return {
        ...state,
        statusUpserting: false,
      };
    case actions.GET_TAGS.REQUEST:
      return {
        ...state,
        tagsFetching: true,
      };
    case actions.GET_TAGS.SUCCESS:
    case actions.GET_TAGS.FAILURE:
      return {
        ...state,
        tagsFetching: false,
      };
    case actions.UPSERT_TAGS.REQUEST:
      return {
        ...state,
        tagsUpserting: true,
      };
    case actions.UPSERT_TAGS.SUCCESS:
    case actions.UPSERT_TAGS.FAILURE:
      return {
        ...state,
        tagsUpserting: false,
      };
    case actions.GET_BOARDS.REQUEST:
      return {
        ...state,
        boardsFetching: true,
      };
    case actions.GET_BOARDS.SUCCESS:
    case actions.GET_BOARDS.FAILURE:
      return {
        ...state,
        boardsFetching: false,
      };
    case actions.UPSERT_BOARD.REQUEST:
      return {
        ...state,
        boardsUpserting: true,
      };
    case actions.UPSERT_BOARD.SUCCESS:
    case actions.UPSERT_BOARD.FAILURE:
      return {
        ...state,
        boardsUpserting: false,
      };
    case actions.GET_CATEGORIES.REQUEST:
      return {
        ...state,
        categoriesFetching: true,
      };
    case actions.GET_CATEGORIES.SUCCESS:
    case actions.GET_CATEGORIES.FAILURE:
      return {
        ...state,
        categoriesFetching: false,
      };
    case actions.UPSERT_CATEGORY.REQUEST:
      return {
        ...state,
        categoryUpserting: true,
      };
    case actions.UPSERT_CATEGORY.SUCCESS:
    case actions.UPSERT_CATEGORY.FAILURE:
      return {
        ...state,
        categoryUpserting: false,
      };
    case actions.UPSERT.REQUEST:
      return {
        ...state,
        upserting: true,
      };
    case actions.UPSERT.SUCCESS:
    case actions.UPSERT.FAILURE:
      return {
        ...state,
        upserting: false,
      };
    case actions.GET_IS_PROJECT_NAME_UNIQUE.REQUEST:
      return {
        ...state,
        checkingUniqueProjectName: true,
      };
    case actions.GET_IS_PROJECT_NAME_UNIQUE.SUCCESS:
    case actions.GET_IS_PROJECT_NAME_UNIQUE.FAILURE:
      return {
        ...state,
        checkingUniqueProjectName: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/services/api/configuration/project/reducer.js